import styled from 'styled-components'
import tw from 'twin.macro'
import { ButtonLink } from '../base'

export const CardContainer = styled.div`
  ${tw`w-full p-0 py-8 lg:p-8 flex flex-col h-full`}
`

export const ImgWrapper = styled.a`
  ${tw`w-full mb-2 flex-initial bg-white`}
`

export const Img = styled.img`
  ${tw`w-full lg:h-auto`}
`

export const ContentWrapper = styled.div`
  ${tw`flex-1`}
`
export const NameWrapper = styled.div`
  ${tw`w-full px-2 lg:px-0`}
`

export const DetailWrapper = styled.div`
  ${tw`w-full flex flex-wrap px-2 lg:px-0 justify-end self-end`}
`
export const Detail = styled.div`
  ${tw`w-full lg:w-1/2 py-2 lg:py-4`}
`

export const ButtonWrapper = styled.div`
  ${tw`w-full lg:w-1/2 text-right flex justify-end content-end items-start py-2 lg:py-4`}
`

export const Button = styled(ButtonLink)`
  ${tw`py-4 px-8 text-center`}
`
